<template>
  <div class="admin-saved-filters">
    <v-select
      v-model="selected"
      :items="saved"
      item-text="name"
      item-value="name"
      label="Kayıtlı filtreler"
      outlined
      dense
      hide-details
      clearable
      @change="apply"
    />
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          title="Filtreleri kaydet"
          aria-label="Filtreleri kaydet"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>{{ icons.mdiBookmarkPlusOutline }}</v-icon>
        </v-btn>
      </template>
      <v-card
        class="pa-4"
        width="280"
      >
        <v-text-field
          v-model="name"
          label="Filtre adı"
          maxlength="50"
          outlined
          dense
          @keyup.enter="save"
        /><v-alert
          v-if="error"
          type="error"
          dense
          text
        >
          {{ error }}
        </v-alert><v-btn
          color="primary"
          small
          :disabled="!name.trim()"
          @click="save"
        >
          Kaydet
        </v-btn>
      </v-card>
    </v-menu>
    <v-btn
      icon
      title="Kayıtlı filtreyi kaldır"
      aria-label="Kayıtlı filtreyi kaldır"
      :disabled="!selected"
      @click="remove"
    >
      <v-icon>{{ icons.mdiBookmarkRemoveOutline }}</v-icon>
    </v-btn>
  </div>
</template>
<script>
import { mdiBookmarkPlusOutline, mdiBookmarkRemoveOutline } from '@mdi/js'
import { getPanelSession } from '@/utils/panelSession'

export default {
  props: { storageKey: { type: String, required: true }, value: { type: Object, required: true } },
  data: () => ({
    icons: { mdiBookmarkPlusOutline, mdiBookmarkRemoveOutline }, saved: [], selected: null, name: '', menu: false, error: '',
  }),
  computed: { key() { return `panel-filters:${getPanelSession()?.id || 'unknown'}:${this.storageKey}` } },
  mounted() {
    try {
      const rows = JSON.parse(localStorage.getItem(this.key) || '[]')
      this.saved = Array.isArray(rows) ? rows.filter(row => row && typeof row.name === 'string' && row.values && typeof row.values === 'object').slice(0, 10) : []
    } catch (_) { this.saved = [] }
  },
  methods: {
    sanitize(values) {
      return Object.fromEntries(Object.keys(this.value).map(key => {
        const value = values[key]

        if (typeof value === 'string') return [key, value.slice(0, 200)]
        if (typeof value === 'number' || typeof value === 'boolean' || value === null) return [key, value]

        return [key, this.value[key]]
      }))
    },
    persist(rows) {
      try {
        localStorage.setItem(this.key, JSON.stringify(rows)); this.saved = rows

        return true
      } catch (_) {
        this.error = 'Tarayıcıya kaydedilemedi.'

        return false
      }
    },
    save() {
      const name = this.name.trim().slice(0, 50)
      if (!name) return
      const rows = this.saved.filter(row => row.name !== name)
      if (rows.length >= 10) {
        this.error = 'En fazla 10 filtre kaydedilebilir.'

        return
      }
      if (this.persist([...rows, { name, values: this.sanitize(this.value) }])) { this.menu = false; this.selected = name; this.error = '' }
    },
    apply(name) { const row = this.saved.find(item => item.name === name); if (row) this.$emit('apply', this.sanitize(row.values)) },
    remove() { if (this.persist(this.saved.filter(row => row.name !== this.selected))) this.selected = null },
  },
}
</script>
<style scoped>
.admin-saved-filters { display: flex; align-items: center; gap: 4px; width: min(100%, 360px); }
.admin-saved-filters > .v-input { min-width: 0; }
</style>
